// @flow

import { graphql } from 'react-relay';
import createRelayMutation from 'shared/gql/createRelayMutation';

const mutation = graphql`
  mutation UpdateUserSavedFilterMutation($input: UpdateUserSavedFilterInput) {
    updateUserSavedFilter(input: $input) {
      userSavedFilterEdge {
        node {
          id
          name
          type
          filter
        }
      }
    }
  }
`;

export default {
  commit: createRelayMutation.bind(null, mutation),
};
